/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Room_Setpoint_Temperature_Tooltip_ManualInputs */



/**
* | output |
* | --- |
* | "The three-way valve is in forcing mode, the setpoint is no longer used" |
*
* @param {Boiler_Room_Setpoint_Temperature_Tooltip_ManualInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_room_setpoint_temperature_tooltip_manual = /** @type {((inputs?: Boiler_Room_Setpoint_Temperature_Tooltip_ManualInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Room_Setpoint_Temperature_Tooltip_ManualInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The three-way valve is in forcing mode,\nthe setpoint is no longer used")
	return /** @type {LocalizedString} */ ("La vanne 3 voies est en forçage,\nla consigne n'est plus utilisée")
});